// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"5473862a","256":"aa7a0d92","293":"a7352f76","341":"ac9f0da8","353":"018012e0","364":"3a1bfaed","396":"e08013be","568":"efb74abe","599":"0aba3df2","670":"06a644e8"}[chunkId] + ".chunk.js";
};